// extracted by mini-css-extract-plugin
module.exports = {"heading":"LinkedHeading_heading__RezUA","offsetAnchor":"LinkedHeading_offsetAnchor__HlADD","stickyHeading":"LinkedHeading_stickyHeading__MwejA"};